import { render, staticRenderFns } from "./simple-modal.vue?vue&type=template&id=5f59c070&scoped=true&"
import script from "./simple-modal.vue?vue&type=script&lang=js&"
export * from "./simple-modal.vue?vue&type=script&lang=js&"
import style0 from "./simple-modal.vue?vue&type=style&index=0&id=5f59c070&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59c070",
  null
  
)

export default component.exports